import { render } from "./InfoLicenseModal.vue?vue&type=template&id=02ee71a7"
import script from "./InfoLicenseModal.vue?vue&type=script&lang=js"
export * from "./InfoLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__